<div class="inline-flex items-center rounded w-max text-[14px]">
  <button class="px-3 py-1 font-medium rounded-l" (click)="decrement()">-</button>
  <input
    type="text"
    [value]="value"
    (input)="onInput($event)"
    class="w-[30px] h-[30px] text-center border-[1px] bg-transparent border-custom-black rounded-md outline-none"
  />
  <button class="px-3 py-1 font-medium rounded-r"
          (click)="increment()">+</button>
</div>
